import Component from './tick-list';
export default Component;
